import { Text } from "@radix-ui/themes";
import { useState } from "react";
import { FileType, UploadItem } from "./UploadItem";
import { useIES } from "../../hooks/useIES";

const UploadImages = () => {
    const { IES, isLoading } = useIES();
  
  const [uploads] = useState<{ type: FileType; initialPreview?: string }[]>([
    { type: "favicon", initialPreview: IES.FAVICON},
    { type: "logo", initialPreview: IES.LOGO },
    { type: "background", initialPreview: IES.BACKGROUND },
  ]);

  return (
    <div style={{ padding: "24px", maxWidth: "1200px" }}>
      <Text color="gray" size="2" mb="4">
        Faça upload das imagens que serão utilizadas no sistema
      </Text>
      {uploads.map((item, index) => (
        <UploadItem key={index} type={item.type} initialPreview={item.initialPreview} />
      ))}
    </div>
  );
};

export default UploadImages;